// pages/PrivacyPage.tsx
import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <div className="pt-20 min-h-screen bg-gray-50">
      <div className="bg-gradient-to-br from-blue-900 via-purple-900 to-pink-900 py-20 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 text-center">
            Tietosuojaseloste
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto text-center">
            FennoFuture - Henkilötietojen käsittely
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-gray-50 via-gray-50/50 to-transparent pointer-events-none" />
      </div>

      <div className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">

            <section>
              <h2 className="text-2xl font-bold mb-4">1. Rekisterinpitäjä</h2>
              <p className="text-gray-700 mb-2"><strong>FennoFuture</strong></p>
              <p className="text-gray-700">Y-tunnus: 3203489-7</p>
              <p className="text-gray-700">Turuntie 3, 37830 Akaa</p>
              <p className="text-gray-700">Sähköposti: innovation@fennofuture.fi</p>
              <p className="text-gray-700">Puhelin: +358 400 416 466</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">2. Rekisterin nimi</h2>
              <p className="text-gray-700">FennoFuture asiakasrekisteri ja verkkosivuston käyttäjärekisteri</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">3. Henkilötietojen käsittelyn tarkoitus</h2>
              <p className="text-gray-700 mb-3">Käsittelemme henkilötietoja seuraaviin tarkoituksiin:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Asiakassuhteen hoitaminen ja ylläpito</li>
                <li>Tarjousten ja tilausten käsittely</li>
                <li>Laskutus ja maksuliikenne</li>
                <li>Yhteydenottoihin vastaaminen</li>
                <li>Palveluiden kehittäminen</li>
                <li>Markkinointi (suostumuksen perusteella)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">4. Rekisterin tietosisältö</h2>
              <p className="text-gray-700 mb-3">Rekisteri voi sisältää seuraavia tietoja:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Nimi</li>
                <li>Yhteystiedot (osoite, puhelinnumero, sähköposti)</li>
                <li>Yrityksen nimi ja Y-tunnus</li>
                <li>Laskutustiedot</li>
                <li>Asiakassuhteeseen liittyvät tiedot</li>
                <li>Verkkosivuston käyttötiedot (evästeet, IP-osoite)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">5. Tietojen säilytysaika</h2>
              <p className="text-gray-700">
                Säilytämme henkilötietoja niin kauan kuin se on tarpeen käsittelyn tarkoituksen toteuttamiseksi
                tai lain edellyttämän ajan. Asiakastiedot säilytetään vähintään kirjanpitolain edellyttämän ajan (6 vuotta).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">6. Tietojen luovutus</h2>
              <p className="text-gray-700 mb-3">
                Emme luovuta henkilötietoja kolmansille osapuolille ilman suostumustanne, paitsi:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Lakisääteisen velvollisuuden täyttämiseksi</li>
                <li>Palvelun toimittamiseen tarvittaville yhteistyökumppaneille (esim. maksupalvelut)</li>
                <li>Viranomaisten pyynnöstä lain edellyttämissä tapauksissa</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">7. Rekisteröidyn oikeudet</h2>
              <p className="text-gray-700 mb-4">
                Teillä on seuraavat GDPR:n mukaiset oikeudet henkilötietojenne käsittelyyn liittyen:
              </p>

              <div className="space-y-6">
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Tarkastusoikeus (Oikeus saada pääsy tietoihin)</h3>
                  <p className="text-gray-700 text-sm">
                    Teillä on oikeus saada tieto siitä, käsitelläänkö henkilötietojanne, ja jos käsitellään, oikeus
                    saada pääsy henkilötietoihin sekä jäljennös käsiteltävistä henkilötiedoista. Voitte pyytää tietoa
                    käsittelyn tarkoituksesta, tietoluokista, vastaanottajista ja säilytysajoista.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Oikeus tietojen oikaisemiseen</h3>
                  <p className="text-gray-700 text-sm">
                    Jos henkilötietonne ovat virheellisiä tai puutteellisia, teillä on oikeus vaatia niiden
                    oikaisemista tai täydentämistä. Pyrimme korjaamaan virheet viipymättä, viimeistään kuukauden
                    kuluessa pyynnöstä.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Oikeus tietojen poistamiseen ("Oikeus tulla unohdetuksi")</h3>
                  <p className="text-gray-700 text-sm mb-2">
                    Teillä on oikeus pyytää henkilötietojenne poistamista tietyissä tilanteissa, esimerkiksi silloin
                    kun tietoja ei enää tarvita niihin tarkoituksiin, joihin ne on kerätty, tai jos peruutatte antamanne suostumuksen.
                  </p>
                  <p className="text-gray-700 text-sm">
                    Tärkeä rajoitus: Emme voi poistaa henkilötietoja, joiden säilyttäminen on lakisääteisesti velvoitettua.
                    Kirjanpitolain mukaan liiketapahtumia koskevia tietoja (kuten laskuja, sopimuksia ja maksutositteita)
                    on säilytettävä vähintään kuusi (6) vuotta tilikauden päättymisestä. Näitä tietoja ei voida poistaa
                    ennen lakisääteisen säilytysajan päättymistä, vaikka poistamista pyydettäisiin. Tällaisissa tapauksissa
                    rajoitamme tietojen käsittelyn ainoastaan lakisääteiseen säilyttämiseen.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Oikeus käsittelyn rajoittamiseen</h3>
                  <p className="text-gray-700 text-sm">
                    Teillä on oikeus vaatia henkilötietojenne käsittelyn rajoittamista tietyissä tilanteissa,
                    esimerkiksi jos kiistätte tietojen paikkansapitävyyden tai vastustatte käsittelyä. Rajoittamisen
                    aikana tietoja säilytetään, mutta niitä ei käsitellä muutoin.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Vastustamisoikeus</h3>
                  <p className="text-gray-700 text-sm">
                    Teillä on oikeus henkilökohtaiseen erityiseen tilanteeseenne liittyvällä perusteella vastustaa
                    henkilötietojenne käsittelyä, kun käsittely perustuu yleiseen etuun tai oikeutettuun etuumme.
                    Tällöin arvioimme, onko meillä perusteltuja syitä käsittelyyn, jotka syrjäyttävät rekisteröidyn
                    edut ja oikeudet.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Oikeus siirtää tiedot järjestelmästä toiseen</h3>
                  <p className="text-gray-700 text-sm">
                    Teillä on oikeus saada henkilötietonne jäsennellyssä, yleisesti käytetyssä ja koneellisesti
                    luettavassa muodossa ja oikeus siirtää tiedot toiselle rekisterinpitäjälle, jos käsittely
                    perustuu suostumukseen tai sopimukseen ja käsittely tapahtuu automaattisesti.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Oikeus peruuttaa suostumus</h3>
                  <p className="text-gray-700 text-sm">
                    Jos henkilötietojenne käsittely perustuu suostumukseenne, teillä on oikeus peruuttaa suostumuksenne
                    milloin tahansa. Suostumuksen peruuttaminen ei vaikuta ennen peruuttamista suostumuksen perusteella
                    suoritetun käsittelyn lainmukaisuuteen.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Oikeus tehdä valitus valvontaviranomaiselle</h3>
                  <p className="text-gray-700 text-sm">
                    Teillä on oikeus tehdä valitus toimivaltaiselle valvontaviranomaiselle (Suomessa
                    Tietosuojavaltuutetun toimisto, www.tietosuoja.fi), jos katsotte, että henkilötietojenne
                    käsittelyssä rikotaan tietosuoja-asetusta.
                  </p>
                </div>
              </div>

              <div className="mt-6">
                <p className="text-gray-700 font-semibold mb-2">Oikeuksien käyttäminen:</p>
                <p className="text-gray-700 text-sm mb-2">
                  Voitte käyttää oikeuksianne ottamalla yhteyttä:
                </p>
                <p className="text-gray-700 text-sm">
                  Sähköposti: <a href="mailto:innovation@fennofuture.fi" className="text-purple-600 hover:underline">innovation@fennofuture.fi</a><br />
                  Puhelin: <a href="tel:+358400416466" className="text-purple-600 hover:underline">+358 400 416 466</a><br />
                  Postiosoite: FennoFuture, Turuntie 3, 37830 Akaa
                </p>
                <p className="text-gray-700 text-sm mt-2">
                  Vastaamme pyyntöihinne pääsääntöisesti kuukauden kuluessa. Monimutkaisissa tapauksissa voimme
                  pidentää määräaikaa kahdella kuukaudella, josta ilmoitamme teille erikseen.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">8. Tietojen suojaus</h2>
              <p className="text-gray-700">
                Suojaamme henkilötietoja asianmukaisesti teknisillä ja organisatorisilla turvatoimilla.
                Tietoja käsitellään luottamuksellisesti ja vain siihen oikeutetut henkilöt pääsevät niihin käsiksi.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">9. Evästeet</h2>
              <p className="text-gray-700">
                Verkkosivustomme voi käyttää evästeitä käyttökokemuksen parantamiseksi. Voit hallita evästeiden
                käyttöä selaimesi asetuksista.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">10. Muutokset tietosuojaselosteeseen</h2>
              <p className="text-gray-700">
                Pidätämme oikeuden päivittää tätä tietosuojaselostetta. Muutoksista ilmoitetaan verkkosivustollamme.
              </p>
            </section>

            <section className="border-t pt-6">
              <p className="text-sm text-gray-600">
                <strong>Päivitetty:</strong> 8.1.2026
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
